import { ObjectHelper } from 'Code/Helpers/ObjectHelper';

export class IsVisibleOnFilterNotEmptyBaseValueConverter {
    toView(array) {
        let result = array.filter((item) => item.hasOwnProperty('IsVisibleOnFilter') && item['IsVisibleOnFilter'] == true);
        return ObjectHelper.IsNullOrUndefined(result) || result.length <= 0 ? false : true;
    }
}